import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as wa from "./api";

// --- ticket conversation ---

export function useTicketWhatsapp(ticketId: string | null) {
  return useQuery({
    queryKey: ["whatsapp", ticketId],
    queryFn: () => wa.ticketWhatsapp(ticketId as string),
    enabled: ticketId !== null,
  });
}

export function useSendWhatsapp(ticketId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: wa.sendWhatsapp,
    onSuccess: () => {
      if (ticketId) void qc.invalidateQueries({ queryKey: ["whatsapp", ticketId] });
    },
  });
}

// --- templates ---

export function useTemplates(enabled = true) {
  return useQuery({ queryKey: ["wa-templates"], queryFn: wa.listTemplates, enabled });
}

function useInvalidateTemplates() {
  const qc = useQueryClient();
  return () => void qc.invalidateQueries({ queryKey: ["wa-templates"] });
}

export function useCreateTemplate() {
  const inv = useInvalidateTemplates();
  return useMutation({ mutationFn: wa.createTemplate, onSuccess: inv });
}
export function useUpdateTemplate() {
  const inv = useInvalidateTemplates();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<wa.WaTemplateBody> }) =>
      wa.updateTemplate(id, body),
    onSuccess: inv,
  });
}
export function useDeleteTemplate() {
  const inv = useInvalidateTemplates();
  return useMutation({ mutationFn: wa.deleteTemplate, onSuccess: inv });
}
